import React, { useContext, useEffect } from "react";
import { FirebaseContext } from "../components/Firebase";
import Registration from "../containers/Authentication/Registration";
import Usps from "../containers/Home/Usps";
import { navigate } from "gatsby-link";

const LoginPage = () => {
  const { user } = useContext(FirebaseContext);

  // If user is already logged in AND verified, redirect to dashboard
  // Don't redirect unverified users - let them see the registration form or go to verifyEmail
  useEffect(() => {
    if (user && user.emailVerified) {
      navigate("/dashboard");
    }
  }, [user]);

  return (
    <>
      <Registration />
      <Usps />
    </>
  );
};

export default LoginPage;
